import PropTypes from "prop-types"
import React from "react"
import { get } from "lodash/object"
import Results from "../modules/Results"
import ResultsMap from "../modules/ResultsMap"
import State from "../../stores/State"
import { dispatch } from "../../Dispatcher"
import searchMessages from "../../messages/search"
import { injectIntl } from "react-intl"

import {
  SET_BOUNDING_BOX,
  SEARCH_SCROLL_POSITION,
  SEARCH_LOAD_MORE
} from "../../constants"

import { setResultIds } from "../../actions"
import smoothScroll from "../../scripts/smoothScroll"

class SearchResults extends React.Component {
  state = {
    reflowResults: State.get("reflowResults"),
    pageSize: State.get("pageSize"),
    showSearchFilters: State.get("showSearchFilters")
  }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      const showSearchFilters = State.get("showSearchFilters")
      if (showSearchFilters !== this.state.showSearchFilters) {
        this.setState({ showSearchFilters })
        setTimeout(() => this.masonryLayout(), 600)
      }
    })
    this.scrollToResults()
  }

  componentWillUnmount() {
    dispatch({ type: SEARCH_SCROLL_POSITION, pos: window.pageYOffset })
    const edges = get(this.props, ["viewer", "edges"])
    if (edges) {
      dispatch(setResultIds(edges.map(({ node }) => node.id)))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.reflowResults && this.state.reflowResults) {
      setTimeout(() => this.masonryLayout(), 600)
    }
  }

  scrollToResults() {
    const scrollY = State.get("searchScrollPos")
    if (scrollY) {
      const scrollTo = Math.max(parseInt(scrollY, 10), window.pageYOffset)
      if (scrollTo !== window.pageYOffset) {
        window.scrollTo(0, scrollTo)
      }
    } else {
      const {
        total,
        perPage,
        viewer: { resources }
      } = this.props

      if (total && resources.edges) {
        const scrollToCursor = get(resources, [
          "edges",
          ((resources && resources.edges) ? resources.edges.length : 0) - perPage,
          "cursor"
        ])
        if (scrollToCursor) {
          smoothScroll(document.getElementById(scrollToCursor))
        }
      }
    }
  }

  masonryLayout = () => {
    if (this.results) {
      this.results.masonryLayout()
    }
  }

  handleLoadMore = e => {
    e.preventDefault()
    dispatch({ type: SEARCH_LOAD_MORE })
  }

  updateBoundingBox = bbox => {
    dispatch({ type: SET_BOUNDING_BOX, bbox: JSON.stringify(bbox) })
  }

  updateSearchBoundingBox = (bbox, map = false) => {
    dispatch({
      type: "set-search-bounding-box",
      bbox: JSON.stringify(bbox),
      map: map
    })
  }

  render() {
    const {
      intl,
      viewer,
      showSearchFilters,
      articleStyle,
      perPage,
      doQuery: loading,
      map
    } = this.props

    const searchMap = !!map

    const hasNextPage = get(
      viewer,
      ["resources", "pageInfo", "hasNextPage"],
      false
    )
    const resources = get(viewer, ["resources", "edges"])
    const exactLocations = get(viewer, [
      "resources",
      "exact_locations",
      "edges"
    ])

    const resourcesLength = resources ? resources.length : 0
    const pageSize = searchMap ? exactLocations.length : resourcesLength
    const total = get(viewer, ["resources", "total"])
    const loadTo = Math.min(total, pageSize + perPage)

    return (
      <div className="column row">
        {searchMap && (
          <ResultsMap
            exactLocations={exactLocations}
            onMapMoved={this.updateBoundingBox}
            expanded={!showSearchFilters}
            updateSearchBoundingBox={this.updateSearchBoundingBox}
          />
        )}
        {!searchMap && (
          <Results
            resources={resources}
            articleStyle={articleStyle}
            handleLoadMore={this.handleLoadMore}
            loadMoreMessage={
              loading
                ? intl.formatMessage(searchMessages.loading)
                : intl.formatMessage(searchMessages.loadingItems, {
                    from: pageSize + 1,
                    to: loadTo
                  })
            }
            hasNextPage={hasNextPage}
            ref={relay => {
              if (relay && relay.refs) {
                this.results = relay.refs.component
              }
            }}
          />
        )}
      </div>
    )
  }
}

SearchResults.propTypes = {
  viewer: PropTypes.object.isRequired,
  articleStyle: PropTypes.string.isRequired,
  perPage: PropTypes.number,
  showSearchFilters: PropTypes.bool.isRequired
}

export default injectIntl(SearchResults)



// WEBPACK FOOTER //
// ./webapp/components/modules/SearchResults.js